import { translocoConfig } from "@jsverse/transloco";
import { isDevMode } from "@angular/core";

const translocoConfigurations = translocoConfig({
	availableLangs: ["en", "ar"],
	defaultLang: "ar",
	// Remove this option if your application doesn't support changing language in runtime.
	reRenderOnLangChange: true,
	prodMode: !isDevMode(),
	missingHandler: {
		allowEmpty: true,
		logMissingKey: true,
	},
});



export default translocoConfigurations;
